if (!window.serlinoCartUpsellInitialized) {
  window.serlinoCartUpsellInitialized = true;

  const getCartSections = async () => {
    const response = await fetch(
      `${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`
    );

    if (!response.ok) {
      throw new Error(`Cart sections could not be loaded: ${response.status}`);
    }

    return response.json();
  };

  const renderCart = async (sectionData, productId) => {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      return;
    }

    let sections = sectionData;

    if (!sections) {
      sections = await getCartSections();
    }

    cartDrawer.renderContents({
      id: productId,
      sections
    });
  };

  const removeFailedUpsell = async (variantId) => {
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    });
  };

  document.addEventListener('click', async (event) => {
    const addButton = event.target.closest('[data-serlino-upsell-add]');

    if (!addButton || addButton.disabled) return;

    const upsell = addButton.closest('[data-serlino-upsell]');
    const variantId = Number(upsell?.dataset.variantId);
    const discountCode = upsell?.dataset.discountCode?.trim();
    const buttonLabel = addButton.querySelector(
      '[data-upsell-button-label]'
    );

    if (!upsell || !variantId) return;

    event.preventDefault();

    const originalLabel = buttonLabel?.textContent?.trim() || 'Add';

    addButton.disabled = true;

    if (buttonLabel) {
      buttonLabel.textContent = 'Adding...';
    }

    let productAdded = false;

    try {
      const addResponse = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
             {
  id: variantId,
  quantity: 1,
  properties: {
    _serlino_cart_upsell: 'true'
  }
}
            ]
          })
        }
      );

      const addResult = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(
          addResult.description ||
            addResult.message ||
            'Product could not be added.'
        );
      }

      productAdded = true;

      let renderedSections = null;

      if (discountCode) {
        const discountResponse = await fetch(
          `${window.Shopify.routes.root}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              discount: discountCode,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          }
        );

        const discountResult = await discountResponse.json();

        if (!discountResponse.ok) {
          throw new Error(
            discountResult.description ||
              discountResult.message ||
              'Upsell discount could not be applied.'
          );
        }

        renderedSections = discountResult.sections || null;
      }

      if (buttonLabel) {
        buttonLabel.textContent = 'Added';
      }

      await renderCart(renderedSections, variantId);
    } catch (error) {
      console.error('[Serlino cart upsell]', error);

      if (productAdded && discountCode) {
        try {
          await removeFailedUpsell(variantId);
          await renderCart(null, variantId);
        } catch (rollbackError) {
          console.error(
            '[Serlino cart upsell rollback]',
            rollbackError
          );
        }
      }

      addButton.disabled = false;

      if (buttonLabel) {
        buttonLabel.textContent = originalLabel;
      }

      window.alert(
        'The product could not be added with the promotional price. Please try again.'
      );
    }
  });
}

